import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import VividDashboard from './VividDashboard';
import { useOnboarding } from '../../context/OnboardingContext';
import { buildBotPath } from '../../utils/routes';

const DashboardPage = () => {
    const { bot_id } = useParams();
    const { subscriptionStatus, refreshStatus } = useOnboarding();

    // The context loads once per authorised session, so without this the screen would keep showing
    // whatever was cached when the app started — including an `inactive` status captured while the
    // first payment was still being processed.
    useEffect(() => {
        refreshStatus().catch(() => undefined);
    }, [refreshStatus]);

    // Reached by navigating straight to the URL: once the block bites there is no dashboard to show.
    if (subscriptionStatus?.block?.state === 'active') {
        return <Navigate to={buildBotPath(bot_id, '/onboarding/blocked')} replace />;
    }

    return <VividDashboard />;
};

export default DashboardPage;
